import { useCallback, useState } from 'react';
import { last } from 'lodash';

import { useSuggests } from '../../hooks';
import { validateStake } from '../../utils';

interface Input {
    value: string;
    changeValue: (stake: string) => void;
    maxStake: string;
}

interface Output {
    setStake: InputEl['onChange'];
    stakes: number[];
    onFocus: VoidFn;
    onBlur: InputEl['onBlur'];
    isInputFocused: boolean;
}

export default function useBetslipStakeInput({
    value,
    changeValue,
    maxStake,
}: Input): Output {
    const { suggests } = useSuggests({
        maxStake,
    });

    const [isInputFocused, setIsInputFocused] = useState<boolean>(false);

    const onFocus = useCallback(() => {
        setIsInputFocused(true);
        changeValue('');
    }, [changeValue]);

    const onBlur = useCallback(() => {
        setIsInputFocused(false);
    }, []);

    const maxValue = last(suggests);

    const setStake: InputEl['onChange'] = useCallback(
        e => {
            const { value: currValue } = e.currentTarget;

            const nextValue = validateStake({
                value: currValue,
                maxValue: Number(maxValue),
            });

            if (nextValue == null || value === nextValue) return;

            changeValue(nextValue);
        },
        [maxValue, value, changeValue]
    );

    return {
        setStake,
        stakes: suggests,
        isInputFocused,
        onFocus,
        onBlur,
    };
}
